export default __webpack_public_path__ + "static/media/hospitalisation-surgical-icon.d6a06858.svg";